import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
export const DASHBOARD_TOTAL_ATTENADOPRATE = "DASHBOARD_TOTAL_ATTENADOPRATE";

const dashboardAttenadoprateCount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=attenadoprateCnt`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "attenadoprateCnt",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for ..
        dispatch({
          type: DASHBOARD_TOTAL_ATTENADOPRATE,
          payload: { count: data.count },
        });
        callback({
          error: 0,
          data: "Analytics Logged in users who actually attended the event !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export { dashboardAttenadoprateCount };
